var map = {
	"./bg/strings.json": 1878,
	"./cs/strings.json": 1879,
	"./da/strings.json": 1880,
	"./de/strings.json": 1881,
	"./el/strings.json": 1882,
	"./es-419/strings.json": 1883,
	"./es/strings.json": 1884,
	"./et/strings.json": 1885,
	"./fi/strings.json": 1886,
	"./fr-CA/strings.json": 1887,
	"./fr/strings.json": 1888,
	"./it/strings.json": 1889,
	"./lt/strings.json": 1890,
	"./lv/strings.json": 1891,
	"./nl/strings.json": 1892,
	"./no/strings.json": 1893,
	"./pl/strings.json": 1894,
	"./pseudo/strings.json": 1895,
	"./pt/strings.json": 1896,
	"./ro/strings.json": 1897,
	"./sk/strings.json": 1898,
	"./sl/strings.json": 1899,
	"./sv/strings.json": 1900,
	"./zh-CN/strings.json": 1901,
	"./zh-TW/strings.json": 1902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1877;